import React from "react";
import { Loading } from "../../App";
import FocusMenu from "./FocusMenu";
import Searchproduct from "./Searchproduct";
import StockManagement from "./StockManagement";
import Navbar from "../navbar/Navbar";
import { Route } from "react-router-dom";
import Home from "./Home";
import AddedStocks from "../stock/AddedStocks";
import SalesRecords from "../sales/SalesRecords";
import queryString from "query-string";
import AllStocks from "../stock/AllStocks";
import CashOutFlow from "../cashoutflow/CashOutFlow";
import Charts from "../charts/Charts";
import Welcome from "./Welcome";
import NewShop from "./NewShop";

class Management extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isAuthenticated: localStorage.getItem("token") ? true : false,
      user: JSON.parse(localStorage.getItem("user")),
      institutions: {},
      subBranches: {},
      wareHouses: {},
      focus: "shop",
      focusObj: null,
    };

    this.setAuthUser = this.setAuthUser.bind(this);
    this.setShops = this.setShops.bind(this);
    this.setCurrentFocus = this.setCurrentFocus.bind(this);
  }

  setCurrentFocus(focus, focusObj) {
    this.setState({
      focus: focus,
      focusObj: focusObj,
    });
  }

  async setShops(user) {
    console.log("setting shops");
    if (user.institutions) {
      let inst = {};
      user.institutions.forEach((element) => {
        inst[element.vehhealth_id] = element;
      });

      let sub = {};
      user.sub_branches.forEach((element) => {
        sub[element.token] = element;
      });

      let ware = {};
      if (user.ware_houses.length > 0) {
        user.ware_houses.forEach((element) => {
          ware[element.token] = element;
        });
      }

      this.setState({
        institutions: inst,
        subBranches: sub,
        wareHouses: ware,
      });
    } else {
      this.setState({
        institutions: null,
        subBranches: null,
        wareHouses: null,
      });
    }
  }

  async setAuthUser(user) {
    if (user) {
      await this.setShops(user);
      this.setState({
        user: user,
        isAuthenticated: true,
      });
    } else {
      this.setState({
        user: null,
        isAuthenticated: false,
      });
      localStorage.clear();
    }
  }

  async componentDidMount() {
    let user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      await this.setAuthUser(user);
      this.setState({
        ready: true,
      });
    }
  }

  render() {
    if (this.state.isAuthenticated) {
      if (this.state.ready) {
        if (this.state.institutions) {
          return (
            <div>
              <Navbar state={this.state} setAuthUser={this.state.setAuthUser} />
              <div>
                <br />
                <br />
                <br />
              </div>
              <section className="">
                <div className="container">
                  <div className="columns">
                    <div className="column is-6">
                      <FocusMenu
                        state={this.state}
                        setCurrentFocus={this.setCurrentFocus}
                      />
                    </div>
                    <div className="column is-6">
                      <Searchproduct state={this.state} />
                    </div>
                  </div>

                  {this.state.focusObj ? (
                    <div>
                      <Route
                        path="/myshop/home/"
                        render={(props) => (
                          <Home
                            {...props}
                            focusObj={this.state.focusObj}
                            focus={this.state.focus}
                          />
                        )}
                      />
                      <Route
                        path="/myshop/all-stocks/"
                        render={(props) => (
                          <AllStocks
                            {...props}
                            focusObj={this.state.focusObj}
                            focus={this.state.focus}
                          />
                        )}
                      />
                      <Route
                        path="/myshop/stocks-added/"
                        render={(props) => (
                          <AddedStocks
                            {...props}
                            focusObj={this.state.focusObj}
                            focus={this.state.focus}
                          />
                        )}
                      />
                      <Route
                        path="/myshop/sales/sales-records/"
                        render={(props) => (
                          <SalesRecords
                            {...props}
                            focusObj={this.state.focusObj}
                            focus={this.state.focus}
                          />
                        )}
                      />
                      <Route
                        path="/myshop/charts/"
                        render={(props) => (
                          <Charts
                            {...props}
                            focusObj={this.state.focusObj}
                            focus={this.state.focus}
                          />
                        )}
                      />
                      <Route
                        path="/myshop/cash-outflow/"
                        render={(props) => (
                          <CashOutFlow
                            {...props}
                            focusObj={this.state.focusObj}
                            focus={this.state.focus}
                          />
                        )}
                      />
                      <Route
                        path="/myshop/home/edit-stock/"
                        render={(props) => (
                          <StockManagement
                            {...props}
                            focusObj={this.state.focusObj}
                            focus={this.state.focus}
                          />
                        )}
                      />
                      }/>
                    </div>
                  ) : (
                    <div className="mt-4">
                      <Loading />
                    </div>
                  )}
                </div>
              </section>
            </div>
          );
        } else {
          return (
            <div>
              <Navbar state={this.state} setAuthUser={this.state.setAuthUser} />

              <div>
                <Route
                  path="/myshop/home/"
                  render={(props) => (
                    <Welcome {...props} user={this.state.user} />
                  )}
                />
                <Route
                  path="/myshop/create/"
                  render={(props) => <NewShop {...props} />}
                />
              </div>
            </div>
          );
        }
      } else {
        return (
          <div className="">
            <br />
            <br />
            <br />
            <br />
            <Loading />
          </div>
        );
      }
    } else {
      let path = this.props.location.pathname + "?";
      try {
        let params = queryString.parse(this.props.location.search);
        if (params) {
          Object.keys(params).forEach((key) => {
            path += key + "=" + params[key] + "&";
          });
        }
      } catch (e) {
        console.log(e);
      }
      return window.location.assign("/login/?next=" + path);
    }
  }
}

export default Management;
